import React from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Tooltip, { TooltipProps } from "@material-ui/core/Tooltip";

const useStylesBootstrap = makeStyles((theme: Theme) => ({
  arrow: {
    color: theme.palette.common.black
  },
  tooltip: {
    backgroundColor: theme.palette.common.black,
    padding: 10,
    fontSize: 12
  }
}));

export default function CustomizedTooltips(props: TooltipProps) {
  const classes = useStylesBootstrap();
  const { children } = props;
  return (
    <div>
      <Tooltip arrow classes={classes} {...props}>
        {children}
      </Tooltip>
    </div>
  );
}